import { Component, Input } from '@angular/core';
import { Banner } from '@motivforce/mx-library-angular';

@Component({
  selector: 'app-milestone-main-layout',
  templateUrl: './milestone-main-layout.component.html',
  styleUrls: ['./milestone-main-layout.component.scss'],
})
export class MilestoneMainLayoutComponent {
  @Input() banner: Banner | null;
}
